<template>
  <v-container fluid>
    <v-row v-if="!loading">
      <v-col v-for="(org, index) in organograms" :key="index" cols="12">
        <v-card class="mb-4">
          <v-card-title>{{ org.division.name }} Division Organogram</v-card-title>
          <v-card-text>
            <OrganogramFlow
              :employees="org.employees"
              :layout="org.layout"
              :isAdmin="false"
              :divisionName="org.division.name"
              :loggedInUserId="loggedInUserId"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="organograms.length === 0" cols="12">
        <v-alert type="info">No division assigned or organogram not available.</v-alert>
      </v-col>
    </v-row>
    <div v-else class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import OrganogramFlow from '@/components/OrganogramFlow.vue';

export default {
  name: 'MyTeamOrganogram',
  components: {
    OrganogramFlow
  },
  data() {
    return {
      organograms: [],
      loading: true,
      loggedInUserId: null
    };
  },
  async created() {
    this.loggedInUserId = localStorage.getItem('userid');
    await this.fetchOrganograms();
  },
  methods: {
    async fetchOrganograms() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/my-team/organogram', {
          headers: { 'x-auth-token': token }
        });
        if (res.data && res.data.status) {
          this.organograms = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching organograms:", e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
